import segment from 'src/js/modules/analytics/segment';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';

const trackSwitchBlockLayoutButtonClicked = ({ blockId, blockVariationId }) => {
  if (!blockId) return;

  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.SWITCH_BLOCK_LAYOUT_BUTTON_CLICKED, {
    dialogId: dialogTypes.BLOCK_SETTINGS,
    blockId,
    blockVariationId,
  });
};

export default trackSwitchBlockLayoutButtonClicked;
